<template>
    <el-form size="mini" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <el-form-item style="justify-content:flex-end;display: flex;">
            <el-button type="primary" @click="submitForm('ruleForm')" :loading="loading">立即创建</el-button>
            <el-button @click="resetForm('ruleForm')">重置</el-button>
        </el-form-item>
        <el-tabs :tab-position="'top'" v-model="activeIndex" label-position="top">
            <el-tab-pane label="基本信息" name="0">
                <el-row :gutter="10">
                    <el-col :span="8">
                        <el-form-item label="商品名称" prop="name">
                            <el-input v-model="ruleForm.name"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <!-- <el-form-item label="商品分类" prop="categoryid">
                                    <el-select v-model="selectTree" clearable filterable placeholder="请选择商品分类">
                                        <el-option :value="selectTree" :label="selectName" style="height: auto">
                                            <el-tree :data="treeData" ref="tree" :props="defaultProps" node-key="id"
                                                :accordion="true" @node-click="handleNodeClick"></el-tree>
                                        </el-option>
                                    </el-select>
                                </el-form-item> -->
                        <el-form-item label="商品分类" prop="categoryid">
                            <select-tree ref="selectTree" :treeList="returnDropList" nodeKey="treeid"
                                :defaultData="defaultData" :treeProps="treeProps"
                                @handleNodeClick="selectDrop"></select-tree>
                        </el-form-item>

                    </el-col>
                </el-row>
                <el-row :gutter="10">
                    <el-col :span="8">
                        <el-form-item label="是否上架" prop="on_off_status">
                            <el-switch v-model="ruleForm.on_off_status" active-color="#13ce66" inactive-color="#d2d2d2"
                                active-value="1" inactive-value="2">
                            </el-switch>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="排序" prop="sortid">
                            <el-input v-model="ruleForm.sortid" type="number"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="10">
                    <el-col :span="8">
                        <el-form-item label="材质" prop="material">
                            <el-input v-model="ruleForm.material"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="工艺" prop="technology">
                            <el-input v-model="ruleForm.technology"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="10">
                    <el-col :span="8">
                        <el-form-item label="面料" prop="fabric">
                            <el-input v-model="ruleForm.fabric"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="填充物" prop="filler">
                            <el-input v-model="ruleForm.filler"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="10">
                    <el-col :span="8">
                        <el-form-item label="缩略图" prop="picurl">
                            <el-upload class="avatar-uploader" action="/mallapi/MallApi/file/upload" :show-file-list="false"
                                :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
                                <img v-if="ruleForm.picurl" :src="ruleForm.picurl" class="avatar">
                                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                <div class="el-upload__tip" slot="tip" style="font-weight: bold">图片只能是 JPG 格式，且不超过2M
                                </div>
                            </el-upload>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-tab-pane>
            <el-tab-pane label="商品规格" name="1">
                <el-row :gutter="10">
                    <el-form-item>
                        <el-button type="success" @click="addDomain">新增规格</el-button>
                        <el-button type="info" @click="showdetail()">生成规格明细</el-button>
                        <el-button type="warning" @click="defaultNow()">重置规格</el-button>
                    </el-form-item>
                </el-row>
                <el-row :gutter="10">
                    <el-form ref="specForm" :inline="true" :model="specmodel" :rules="domainsrules">
                        <el-row v-for="(domain, index) in specmodel.domains" :key="index">
                            <el-form-item :prop="'domains.' + index + '.name'" :label="'规格'" :rules="domainsrules.name">
                                <el-input v-model="domain.name" placeholder="输入规格名"></el-input>
                            </el-form-item>
                            <el-form-item :prop="'domains.' + index + '.value'" :rules="domainsrules.value">
                                <el-input v-model="domain.value" placeholder="输入规格值(以中文逗号隔开)"></el-input>
                            </el-form-item>
                            <el-form-item>
                                <el-button @click.prevent="removeDomain(domain)">删除</el-button>
                            </el-form-item>
                        </el-row>
                    </el-form>

                </el-row>
                <el-row :gutter="10">
                    <el-col :span="8"> <el-button type="danger" icon="el-icon-delete" @click="promotion()"
                            v-if="isshow">批量删除</el-button></el-col>
                    <el-table v-if="isshow" :data="tableData" @selection-change="handleSelectionChange" style="width: 100%"
                        border>
                        <el-table-column type="selection" width="55"></el-table-column>
                        <el-table-column type="index" label="序号"></el-table-column>
                        <el-table-column v-for="(item, index) in columns" :key="index" :label="item.label"
                            :prop="item.prop"></el-table-column>
                        <el-table-column prop="stock" label="库存">
                            <template slot-scope="scope">
                                <el-input v-model="scope.row.stock"></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column prop="price" label="价格">
                            <template slot-scope="scope">
                                <el-input v-model="scope.row.price"></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column prop="itemno" label="货号">
                            <template slot-scope="scope">
                                <el-input v-model="scope.row.itemno"></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column label="操作">
                            <template slot-scope="scope">
                                <el-button @click.prevent="deleteSpec(scope.$index, scope.row)">删除</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-row>
            </el-tab-pane>
            <el-tab-pane label="商品详情" name="3">
                <el-form-item label="详情图片" prop="imgurl">
                    <el-upload action="/mallapi/MallApi/file/upload" list-type="picture-card"
                        :on-success="handlePictureCardPreview" :before-upload="beforePictureUpload"
                        :on-remove="handleRemove">
                        <i class="el-icon-plus"></i>
                        <div class="el-upload__tip" slot="tip" style="font-weight: bold">大小不超过500KB</div>
                    </el-upload>
                    <el-dialog :visible.sync="dialogVisible">
                        <img width="100%" :src="ruleForm.imgurl" alt="" />
                    </el-dialog>
                </el-form-item>
                <el-form-item prop="content" label="商品详情">
                    <el-card>
                        <!-- <quill-editor v-model="ruleForm.content" ref="myQuillEditor" :options="editorOption">
                                        l-editor></quill-editor> -->
                        <template>
                            <div style="border: 1px solid #ccc;">
                                <Toolbar style="border-bottom: 1px solid #ccc" :editor="editor"
                                    :defaultConfig="toolbarConfig" :mode="mode" />
                                <Editor style="height: 500px; overflow-y: hidden;" v-model="ruleForm.content"
                                    :defaultConfig="editorConfig" :mode="mode" @onCreated="onCreated" />
                            </div>
                        </template>
                    </el-card>
                </el-form-item>
            </el-tab-pane>
        </el-tabs>
    </el-form>
</template>
<script>



import MallApi from "../../../api/goods/goodsapi"
import Api from "../../../api/goods/goodscateapi"
import axios from 'axios'
import selectTree from '@/components/common/selectTree'

import {
    validatetoFixedNew,
} from "../../../utils/validators"
import {
    quillEditor
} from 'vue-quill-editor'

import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

import { Editor, Toolbar } from '@wangeditor/editor-for-vue'
import { IEditorConfig } from '@wangeditor/editor'
import '@wangeditor/editor/dist/css/style.css'



export default {
    name: 'FuncFormsEdit',
    components: {
        Editor, Toolbar, selectTree
    },
    data() {
        return {
            multipleSelection: [],//选中的值
            defaultData: {
                treeid: "-1",
                name: '根目录'
            },
            treeProps: {
                children: 'children',
                label: 'name'
            },
            returnDropList: [],
            //富文本编辑器字段
            editor: null,
            html: '<p>hello</p>',
            toolbarConfig: {
                excludeKeys: [
                    'fullScreen',//不显示全屏
                    'insertVideo',//不显示插入视频
                ]
            },
            editorConfig: {
                placeholder: '请输入内容...',
                MENU_CONF: {
                    // 配置上传图片
                    uploadImage: {
                        customUpload: this.uploadImageMe // this.uploadImageMe 是 methods 中的一个普通方法
                    },
                }
            },
            mode: 'default', // or 'simple'



            //常规字段
            activeIndex: 0,
            detail: "",
            dialogImageUrl: '',
            dialogVisible: false,
            disabled: false,
            content: null,
            editorOption: {},

            //商品分类
            select: {},
            treeData: [],
            selectTree: "",
            selectName: "",
            defaultProps: { label: "name", children: "children" },

            dialogVisible: false,
            loading: false,

            specmodel: {
                domains: [],
            },
            domainsrules: {
                name: [{ required: true, message: '规格名不能为空!', trigger: 'blur' }],
                value: [{ required: true, message: '规格值不能为空!', trigger: 'blur' }]
            },
            //规格数组
            //domains: [],
            //规格明细
            tableData: [],
            isshow: false,
            //规格列名
            columns: [],
            ruleForm: {
                name: "",
                categoryid: "",
                picurl: "",
                on_off_status: "1",
                content: "",
                material: "",
                technology: "",
                fabric: "",
                filler: "",
                sortid: 1,
                imgurl: [],
                detail: "",
                spec: []
            },
            rules: {
                name: [{ required: true, message: "请输入商品名称", trigger: "blur" }],
                categoryid: [{ required: true, message: "请选择商品分类", trigger: "blur" }],
                picurl: [{ required: true, message: "请上传商品缩略图", trigger: "blur" }],
                imgurl: [{ required: true, message: "请上传详情图片", trigger: "blur" }],
                material: [{ required: true, message: "请输入商品材质", trigger: "blur" }],
                technology: [{ required: true, message: "请输入商品工艺", trigger: "blur" }],
                fabric: [{ required: true, message: "请输入商品面料", trigger: "blur" }],
                filler: [{ required: true, message: "请输入商品填充物", trigger: "blur" }],
                content: [{ required: true, message: "请输入商品详情", trigger: "blur" }]
            },
        };
    },
    methods: {


        //单选赋值
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        //批量删除
        promotion() {
            if (this.multipleSelection.length === 0) {
                this.$message.error({
                    showClose: true,
                    message: "至少选中一个规格哦",
                    duration: 2000,
                });
                return;
            } else {
                this.$confirm("确认删除选中规格吗", "提示", { type: "warning" })
                    .then(() => {
                        this.multipleSelection.forEach((item, index) => {
                            var nowIndex = this.tableData.findIndex(v => v.key === item.key)
                            this.tableData.splice(nowIndex, 1)
                        })
                    })
                    .catch(() => { });
            }
        },

        //规格明细表格生成
        showdetail() {
            //有规格才能添加
            if (this.specmodel.domains.length == 0) {
                this.$message.error("您暂未添加规格，无法生成明细");
                return
            }

            //表格验证
            this.$refs['specForm'].validate((valid) => {
                //验证通过
                if (valid) {
                    //*****************生成表单数据并展示
                    this.isshow = true

                    //1.------表头生成
                    this.columns = [] //表头清空
                    this.specmodel.domains.forEach((item, index) => {
                        let col = { 'label': item.name, 'prop': 'name' + index }
                        this.columns.push(col);
                    })

                    //2.------数据生成
                    this.tableData = []
                    let arr = []
                    this.specmodel.domains.forEach(item => {
                        if (item.value != null && item.value != "") {
                            //英文逗号自动转化
                            if (item.value.indexOf(",") > -1) {
                                item.value = item.value.replace(/,/g, "，")
                            }
                            let arry = item.value.split('，');
                            arr.push(arry)
                        }
                    })
                    let data = this.multiplyData(arr)   //排列组合
                    //console.log(data)

                    if (data.length > 0) {
                        data.forEach((item, index) => {
                            //table数据赋值
                            var info = {}
                            this.columns.forEach((o, dex) => {
                                info[o.prop] = item[dex]
                            })
                            info.stock = 0
                            info.price = 0
                            info.itemno = ''
                            info.key = index
                            this.tableData.push(info)
                        })
                    }
                } else {
                    //this.$message.error("有必填项为空，请检查");
                    return
                }
            })
        },
        //重置规格
        defaultNow() {
            this.specmodel.domains = []
            this.columns = []
            this.isshow = false
            this.tableData = []
        },
        //规格新增
        addDomain() {
            this.specmodel.domains.push({
                name: '',
                value: '',
                key: Date.now()
            });
        },
        //规格删除
        removeDomain(item) {
            var index = this.specmodel.domains.indexOf(item)
            if (index !== -1) {
                this.specmodel.domains.splice(index, 1)
            }
        },
        //规格详情删除
        deleteSpec: function (index, row) {
            //var s = Object.assign({}, row);
            //console.log(s)
            let that = this
            this.$confirm("确认删除该规格吗", "提示", { type: "warning" })
                .then(() => {
                    that.tableData.splice(index, 1)
                })
                .catch(() => { });
        },

        //表单保存
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {

                    //规格明细判断（必须大于1）
                    if (this.tableData.length == 0) {
                        this.$message.error("请至少添加一种商品规格")
                        this.activeIndex = "1"
                        return
                    }

                    //规格，规格明细赋值
                    this.ruleForm.detail = this.tableData
                    this.ruleForm.spec = this.specmodel.domains

                    //请求添加接口
                    let that = this;
                    this.loading = true;
                    MallApi.add(this.ruleForm)
                        .then(
                            function (result) {
                                that.loading = false;
                                if (result) {
                                    that.$message.success(result.message);
                                    that.$router.push('/mall/goods/index');
                                }
                            },
                            function (err) {
                                that.loading = false;
                                that.$message.error({
                                    showClose: true,
                                    message: err.toString(),
                                    duration: 2000,
                                });
                            }
                        )
                        .catch(function (error) {
                            that.loading = false;
                            console.log(error);
                            that.$message.error({
                                showClose: true,
                                message: "请求出现异常",
                                duration: 2000,
                            });
                        });
                } else {
                    this.$message.error("有必填项为空，请检查");
                    //console.log("error submit!!");
                    return false;
                }
            });
        },
        //表单重置
        resetForm(formName) {
            this.$refs[formName].resetFields();
            this.imgurl = []
            this.$refs.selectTree.clearSelect()
            this.ruleForm.categoryid = ''
        },

        //商品分类树结构
        Tree() {
            let params = {
                name: null,
                brandid: null
            };
            let that = this;
            Api.getTree(params).then(function (result) {
                if (result.code == 0) {
                    that.treeData = result.data;
                    that.returnDropList = result.data
                }
            },
                function (err) {
                    that.loading = false;
                    that.$message.error({
                        showClose: true,
                        message: err.toString(),
                        duration: 2000,
                    });
                })
        },
        //树目录选择
        handleNodeClick(data) {
            this.ruleForm.categoryid = data.id; //给表单数据项赋值
            this.selectTree = data.id;
            this.selectName = data.name; // 框中显示值为label
        },

        //图片上传
        handleAvatarSuccess(res) {
            if (res.code === 0) {
                this.ruleForm.picurl = "data:image/jpeg;base64," + res.data
            } else {
                this.$message.error(res.message)
            }
        },
        beforeAvatarUpload(file) {
            const isJPG = file.type === 'image/jpeg';
            const isLt2M = file.size / 1024 / 1024 < 2;
            if (!isJPG) {
                this.$message.error('上传头像图片只能是 JPG 格式!');
            }
            if (!isLt2M) {
                this.$message.error('上传头像图片大小不能超过 2MB!');
            }
            return isJPG && isLt2M;
        },


        //商品图片上传相关
        handleRemove(file) {
            this.ruleForm.imgurl.pop(file.response.data);
        },
        beforePictureUpload(file) {
            const isJPG = file.type === 'image/jpeg';
            const isLt2M = file.size / 1024 <= 500;
            if (!isJPG) {
                this.$message.error('上传图片只能是 JPG 格式!');
            }
            if (!isLt2M) {
                this.$message.error('上传图片大小不能超过 500KB!');
            }
            return isJPG && isLt2M;
        },
        handlePictureCardPreview(file) {
            this.ruleForm.imgurl.push("data:image/jpeg;base64," + file.data);
            this.dialogVisible = false;
        },

        multiplyData(newArrData) {
            let len = newArrData.length;
            // 当数组长度大于等于2时
            if (len >= 2) {
                // 第一个数组的长度
                let len1 = newArrData[0].length;
                // 第二个数组的长度
                let len2 = newArrData[1].length;
                //  申明一个新数组,做数据暂存
                let items = new Array();
                // 申明新数组的索引
                let index = 0;
                // 2层嵌套循环,将组合放到新数组中
                for (var i = 0; i < len1; i++) {
                    for (var j = 0; j < len2; j++) {
                        if (items.length < index + 1) {
                            items.push([])
                        }
                        if (newArrData[0][i] instanceof Array) {
                            items[index] = items[index].concat(newArrData[0][i].concat(newArrData[1][j]));
                        } else {
                            items[index] = items[index].concat([newArrData[0][i], newArrData[1][j]]);
                        }
                        index++;
                    }
                }
                // 将新组合的数组并到原数组中
                let newArr = new Array(len - 1);
                for (let i = 2; i < newArrData.length; i++) {
                    newArr[i - 1] = newArrData[i];
                }
                newArr[0] = items;
                // 执行回调
                return this.multiplyData(newArr);
            } else {
                console.log(newArrData[0]);
                return newArrData[0];
            }
        },

        repSign(s) {
            s = s.replace(/([\u4E00-\u9FA5]|^|\n|\r)([\,\.\?\!])(?=[\u4E00-\u9FA5]|$|\n|\r)/g, function (u, v, w, x) {
                let sign = {
                    ',': '，',
                    '.': '。',
                    '?': '？',
                    '!': '！'
                };
                return sign[w] ? v + sign[w] : u;
            });
            return s;
        },

        onCreated(editor) {
            //toolbar.getConfig().toolbarKeys
            this.editor = Object.seal(editor) // 一定要用 Object.seal() ，否则会报错

        },

        //上传文件配置
        uploadImageMe(file, insertFn) {
            // file 即选中的文件
            // 自己实现上传，并得到图片 url alt href

            const isLt2M = file.size / 1024 <= 500;
            if (!isLt2M) {
                this.$message.error('上传图片大小不能超过 500KB!');
                return;
            } else {
                let name = file.name;
                let suffix = file.type.split("/")[1];
                name = name + '.' + suffix;
                console.log("suffix:" + suffix)
                if (suffix != "jpeg") {
                    this.$message.error("上传图片只能是 JPG 格式!")
                    return
                } else {
                    let formdata = new FormData()
                    formdata.append("file", file)

                    let that = this
                    //上传方法
                    axios.post("/mallapi/MallApi/img/upload", formdata).then(function (res) {
                        console.log('response:', res);
                        console.log(res.data.code)
                        if (res.data.code === 0) {
                            insertFn(res.data.data.url)
                        } else {
                            that.$message.error(res.data.data.message);
                        }
                    })
                }
            }




        },
        selectDrop(data, checked) {
            // console.log(data)
            this.ruleForm.categoryid = data
        },


    },
    mounted() {
        this.Tree()
    },
    beforeDestroy() {
        const editor = this.editor
        if (editor == null) return
        editor.destroy() // 组件销毁时，及时销毁编辑器
    }
};
</script>
<style>
.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

.avatar-uploader .el-upload:hover {
    border-color: #409EFF;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
}

.avatar {
    width: 178px;
    height: 178px;
    display: block;
}
</style>
